import { AddressLink } from 'src/shared/api';

export function displayAddress(address: AddressLink) {
	return address.display_name;
}

function toFiveDigits(value: number) {
	return Math.round(value * 100000) / 100000;
}

export function toLatLng(address: AddressLink) {
	return { latitude: address.lat, longitude: address.lon };
}

export function limitLatLngToFiveDigits(latlng: {
	latitude: number;
	longitude: number;
}) {
	return {
		latitude: toFiveDigits(latlng.latitude),
		longitude: toFiveDigits(latlng.longitude),
	};
}
